import MAEvent from './ma-event';
import { typeaheadPlaceFieldDatasets } from './search';

require('jquery-form')();

/**
 *
 * @param {jQuery} $form
 * @param {function} successCallback
 * @param {function} error400Callback
 * @param {function} errorCallback
 * @deprecated Will be remove. Use bindAjaxForm instead
 */
function bindPopinFormEvent($form, successCallback, error400Callback, errorCallback) {
    const $container = $form.parents('[data-reveal]');
    $form.ajaxForm({
        success(response, textStatus, jqXHR) {
            $form.hide();
            $container.find('[data-message-success]').removeClass('hide');
            $form.trigger('submit_success');
            if (typeof successCallback === 'function') {
                successCallback(response, textStatus, jqXHR);
            }
        },
        error(jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 400) {
                $form.trigger('submit_error');
                $container.html(jqXHR.responseText);
                bindPopinFormEvent(
                    $container.find('form'),
                    successCallback,
                    error400Callback,
                    errorCallback,
                );
                if (typeof error400Callback === 'function') {
                    error400Callback(jqXHR, textStatus, errorThrown);
                }
            } else {
                $form.hide();
                $container.find('[data-message-error]').removeClass('hide');
                $form.trigger('submit_error');
                if (typeof errorCallback === 'function') {
                    errorCallback(jqXHR, textStatus, errorThrown);
                }
            }
        },
    });
}

function _removeErrorClass($items) {
    $items.removeClass($items.data('error-class') || 'error');
}

/**
 *
 * @param $form
 * @private
 */
function _removeErrors($form) {
    $form.find('small').remove();

    const $groups = $form.find('[data-control-group]');
    const $fields = $groups.find('[data-control]');
    const $labels = $groups.find('label');
    _removeErrorClass($groups);
    _removeErrorClass($fields);
    _removeErrorClass($labels);
}

/**
 * Display an error for a specific field
 *
 * @param {jQuery} $field The field the error to be displayed
 * @param {array} errorMessages List of errors messages
 * @private
 */
function setFieldError($field, errorMessages) {
    if (!errorMessages) {
        return;
    }
    const $group = $field.parents('[data-control-group]');
    const $label = $group.find('label');
    const $errorPlaceholder = $group.find('[data-control-errors]');
    const errorString = `<small data-field-error class="error field__errors">${errorMessages.join(
        '<br>',
    )}</small>`;

    $group.addClass($group.data('error-class') || 'error');
    $field.addClass($field.data('error-class') || 'error');
    $label.addClass($label.data('error-class') || 'error');
    if ($errorPlaceholder.length > 0) {
        $errorPlaceholder.html(errorString);
    } else {
        $field.parents('[data-control]').append(errorString);
    }
}

/**
 *
 * @param {jQuery} $form The jQuery object representing the form
 * @param {object} errors List of fields errors
 */
function displayErrors($form, errors) {
    let $field;

    _removeErrors($form);

    if (errors) {
        Object.keys(errors).forEach(fieldName => {
            $field = $form.find(`[name="${fieldName}"]`);
            setFieldError($field, errors[fieldName]);
        });
    }
}

/**
 * Bind form to Ajax behavior.
 * @param  {jQueryNode} $form           Form to bind
 * @param  {jQueryNode} $messageSuccess         Message to display on success
 * @param  {Boolean} autoSubmit         Indicate auto submit or not
 * @param  {Function} onSuccess         Callback on success
 * @param  {Function} onFailure          Callback on Failure
 */
function bindAjaxForm($form, $messageSuccess, autoSubmit, onSuccess, onFailure) {
    const $submitButton = $form.find(':submit');

    $form.on('submit', () => {
        $form.trigger(MAEvent.formSubmitAttempt);
    });

    $form.one('change', () => {
        $form.trigger(MAEvent.formStarted);
    });

    if (autoSubmit === false) {
        return;
    }

    $form.ajaxForm({
        dataType: 'json',
        beforeSend() {
            $submitButton.attr('disabled', '');
        },
        success(response) {
            _removeErrors($form);

            $form.trigger(MAEvent.formSubmitSuccess);

            if (response && response.redirect) {
                setTimeout(() => {
                    document.location.href = response.redirect;
                }, 0);
                return;
            }

            if ($messageSuccess && $messageSuccess.length > 0) {
                $form.addClass('hide');
                $messageSuccess.removeClass('hide');
            }

            if (typeof onSuccess === 'function') {
                onSuccess(response);
            }
        },
        complete() {
            $submitButton.removeAttr('disabled');
        },
        error(jqXHR) {
            if (typeof onFailure === 'function') {
                onFailure(jqXHR);
            } else {
                $form.trigger(MAEvent.formSubmitError);

                if (jqXHR.status === 400) {
                    displayErrors($form, jqXHR.responseJSON);
                } else {
                    $submitButton.removeAttr('disabled');
                    throw new Error('Unknow error in Form.bindAjaxForm()');
                }
            }
        },
    });
}

/**
 *
 * @param {jQuery} $form The form containing the errors
 * @param {jQuery} $wrapper
 */
function scrollToFirstError($form, $wrapper) {
    const firstFieldError = $form.find('.error').first();
    if (firstFieldError.length > 0) {
        if (typeof $wrapper === 'undefined') {
            window.scrollTo(0, firstFieldError.offset().top - 20);
        } else {
            $wrapper.scrollTop(firstFieldError.position().top - 20);
        }
    }
}

/**
 *
 * @param {Function} callbackSuccess
 */
export function initializeGeoSearchBoxes(callbackSuccess) {
    const $geoSearchBoxes = $('[data-geo-searchbox]');
    if ($geoSearchBoxes.length === 0) {
        return;
    }

    $geoSearchBoxes.each(function geoSearchBoxEach() {
        const $geoSearchBox = $(this);
        const $geoSearchField = $(this).find('[data-geo-search-field]');

        $geoSearchField.typeahead(
            {
                hint: true,
                highlight: true,
                minLength: 1,
                autoselect: true,
            },
            typeaheadPlaceFieldDatasets($geoSearchField.data('place-types')),
        );

        $geoSearchField.on('typeahead:selected', (event, place) => {
            if (typeof callbackSuccess === 'function') {
                callbackSuccess($geoSearchBoxes, $geoSearchBox, event, place);
            }
        });

        // prevent form submission when using return to select a place
        $geoSearchField.keypress(e => {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });
    });
}

export default {
    bindPopinFormEvent,
    bindAjaxForm,
    displayErrors,
    initializeGeoSearchBoxes,
    scrollToFirstError,
    setFieldError,
};
